import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Alert,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  Grid,
  Button
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  ArrowBack as ArrowBackIcon,
  FilterList as FilterIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import LogAcessoTable from '../../components/Logs/LogAcessoTable';
import { getAccessLogs } from '../../services/logService';
import useLogAccess from '../../hooks/useLogAccess';

const LogAcessoPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { isAdmin } = useLogAccess();

  const fetchLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAccessLogs();
      
      if (response.data && response.data.success) {
        setLogs(response.data.data || []);
      } else {
        setLogs([]);
      }
    } catch (error) {
      console.error('Erro ao buscar logs de acesso:', error);
      setError('Falha ao carregar logs de acesso. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isAdmin) {
      navigate('/unauthorized');
      return;
    }
    fetchLogs();
  }, [isAdmin, navigate]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        {/* Header */}
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Tooltip title="Voltar para Logs">
              <IconButton onClick={() => navigate('/admin/logs')} size="small">
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="h4" component="h1">
              Logs de Acesso
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              variant="contained"
              startIcon={<DashboardIcon />}
              onClick={() => navigate('/dashboard')}
            >
              Voltar ao Dashboard
            </Button>
            <Tooltip title="Atualizar">
              <IconButton onClick={fetchLogs} disabled={loading}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Mensagem de erro */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* Tabela */}
        <LogAcessoTable logs={logs} loading={loading} />
      </Box>
    </Container>
  );
};

export default LogAcessoPage;
